































import {
  Component, Prop, PropSync, Vue,
} from 'vue-property-decorator';
import Overlay from '@/components/Overlay/index.vue';
import PrimaryButton from '@/components/Buttons/PrimaryButton/index.vue';
import TextButton from '@/components/Buttons/TextButton/index.vue';

@Component({
  components: {
    Overlay,
    PrimaryButton,
    TextButton,
  },
})
export default class PartnerConfirmation extends Vue {
  @PropSync('dialog', {}) dialogSync!: boolean;

  @Prop({}) partnerEmail!: string;

  @Prop({}) saving!: string;

  public onSave() {
    this.$emit('save');
  }

  public onCancel() {
    this.dialogSync = false;
    this.$emit('cancel');
  }
}
